import React from "react";
import styled from "@emotion/styled";
import gojek from "../../images/sponsor/gojek.svg";
import tokopedia from "../../images/sponsor/tokopedia.svg";
import grab from "../../images/sponsor/Grab.svg";
import aws from "../../images/sponsor/aws.svg";
import jne from "../../images/sponsor/jneexpress-black.svg";
import ovo from "../../images/sponsor/ovo.svg";
import epson from "../../images/sponsor/Epson.svg";
import futuready from "../../images/sponsor/Futuready.svg";
import dana from "../../images/sponsor/Dana.svg";
import kataaiBlack from "../../images/sponsor/kataai.svg";
import bni from "../../images/sponsor/BNI-black.svg";
import mokaBlack from "../../images/sponsor/Moka.svg";
import mekari from "../../images/sponsor/mekari-black.svg";
import iconplus from "../../images/sponsor/iconplus-black.svg";
import dewawebBlack from "../../images/sponsor/Dewaweb.svg";
import aqua from "../../images/sponsor/aqua-black.svg";
import mandiriBlack from "../../images/sponsor/Mandiri.svg";
import macroad from "../../images/sponsor/Macroad.svg";
import shintavr from "../../images/sponsor/shintavr.svg";
import indomaret from "../../images/sponsor/indomaret.png";
import oyo from "../../images/sponsor/oyo.png";
import medpar from "images/sponsor/medpar.png";
import fasilkom from "images/sponsor/fasilkom.png";
import iluni from "images/sponsor/iluni.png";

const Title = styled.h3`
  color: #000000;
  font-family: ${props => props.theme.fonts.subheading};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 100%;
  }
`;

const LowerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;

  img {
    margin-right: 20px;
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    flex-wrap: wrap;

    img {
      width: 90%;
    }
  }
`;

const LowestContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  img {
    margin-right: 20px;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const SupporterMedpar = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;

    img {
      width: 100%;
    }
  }
`;

export default function SponsorFooter() {
  return (
    <div
      css={{
        marginTop: "100px",
        backgroundColor: "#ffffff",
        padding: "30px 70px",
      }}
    >
      <Title>SPONSORED BY:</Title>
      <Container>
        <a href="https://www.go-jek.com/">
          <img src={gojek} />
        </a>
        <a href="https://www.tokopedia.com/">
          <img src={tokopedia} />
        </a>
        <a href="https://www.grab.com/id/">
          <img src={grab} />
        </a>
      </Container>
      <LowerContainer>
        <a href="https://www.epson.co.id/">
          <img src={epson} />
        </a>
        <a href="https://www.futuready.com/">
          <img src={futuready} />
        </a>
        <a href="https://dana.id/">
          <img src={dana} />
        </a>
        <a href="https://kata.ai/">
          <img src={kataaiBlack} />
        </a>
        <a href="https://shintavr.com/id">
          <img src={shintavr} />
        </a>
      </LowerContainer>
      <LowestContainer>
        <a href="https://www.bni.co.id/id-id/">
          <img src={bni} />
        </a>
        <a href="https://www.jne.co.id/">
          <img src={jne} />
        </a>
        <a href="https://www.mokapos.com/">
          <img src={mokaBlack} />
        </a>
        <a href="https://mekari.com/">
          <img src={mekari} />
        </a>
        <a href="http://www.iconpln.co.id/">
          <img src={iconplus} />
        </a>
        <a href="https://www.dewaweb.com/">
          <img src={dewawebBlack} />
        </a>
        <a href="https://aws.amazon.com/">
          <img src={aws} />
        </a>
        <a href="https://aqua.co.id/">
          <img src={aqua} />
        </a>
        <a href="https://www.ovo.id/">
          <img src={ovo} />
        </a>
        <a href="https://www.bankmandiri.co.id/">
          <img src={mandiriBlack} />
        </a>
        <a href="https://macroad.com/">
          <img src={macroad} />
        </a>
        <a href="https://indomaret.co.id/" css={{ padding: "20px" }}>
          <img src={indomaret} />
        </a>
        <a href="https://www.oyorooms.com/id/" css={{ padding: "20px" }}>
          <img src={oyo} css={{ height: "40px", width: "100px" }} />
        </a>
      </LowestContainer>
      <SupporterMedpar>
        <div>
          <Title>SUPPORTED BY:</Title>
          <img src={fasilkom} css={{ marginBottom: "10px" }} />
          <img src={iluni} />
        </div>
        <div>
          <Title>MEDIA PARTNERS:</Title>
          <img src={medpar} css={{ width: "100%" }} />
        </div>
      </SupporterMedpar>
    </div>
  );
}
